console.log('Webpacker bootstraping assets')

global.jQuery = require('jquery')
global.$ = global.jQuery

import 'jquery'
import 'bootstrap'
import 'chosen-js/chosen.css'
import 'stylesheets/application.scss'

require('@rails/ujs').start()
require('datatables.net-responsive')
require('datatables.net-bs4')
require('datatables.net-buttons-bs4')
require('datatables.net-buttons/js/buttons.html5.js')
